export class CalculoCartaCreditoVO {

  valorCredito: number;
  valorExcedenteAcumulado: number;
  valorExcedenteAcumuladoCalculado: number;
  valorLimiteCredito: number;
  valorExcedente: number;
  valorExcendenteUtilizado: number;
  valorExcedenteUtilizadoTecnac: number;
  valorRemanescenteAcumulado: number;
  valorRemanescente: number;
  valorRemanescenteUtilizado: number;
  valorRemanescenteTecnac: number;

}
